export default __webpack_public_path__ + "static/community-8ae776ec1d6edaf777cd8bea628e37f9.jpg";